import React from 'react';
import { FiCalendar } from 'react-icons/fi';
import { DateInputWrapper, DateInput, DateInputIcon } from './CustomDateRangeInput.styles';

type Props = {
  value?: string;
  onClick?: () => void;
  placeholder?: string;
};

const CustomDateRangeInput = React.forwardRef<HTMLInputElement, Props>(
  ({ value, onClick, placeholder }, ref) => (
    <DateInputWrapper onClick={onClick} ref={ref as any}>
      <DateInput
        type="text"
        readOnly
        value={value}
        placeholder={placeholder}
      />
      <DateInputIcon>
        {FiCalendar({ size: 18 })}
      </DateInputIcon>
    </DateInputWrapper>
  )
);

export default CustomDateRangeInput;
